import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#000",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M2.26 15.233c.038-.344.057-.517.11-.678q.07-.215.194-.404c.093-.141.215-.264.46-.509L14.03 2.637a2.357 2.357 0 1 1 3.333 3.333L6.358 16.975c-.245.246-.368.368-.51.461a1.7 1.7 0 0 1-.403.195c-.161.052-.334.07-.678.11l-2.82.313z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }